class ArticleShortcodes extends HTMLElement {
  connectedCallback() {
    this.process();
  }

  process() {
    const html = this.innerHTML;

    const pattern = /\[([\s\S]*?)\]/gi;

    const replacedHtml = html.replace(pattern, (fullMatch, innerContent) => {
      const cleanContent = innerContent.replace(/<[^>]*>?/gm, "").trim();

      const nameMatch = cleanContent.match(/^([a-zA-Z0-9_-]+)/);

      if (!nameMatch) return fullMatch;

      const shortcodeName = nameMatch[1].toLowerCase();

      const attrString = cleanContent.substring(nameMatch[0].length);
      const attrs = this.parseAttrs(attrString);

      return this.renderShortcode(shortcodeName, attrs, fullMatch);
    });

    if (html !== replacedHtml) {
      this.innerHTML = replacedHtml;
    }
  }

  parseAttrs(str) {
    const attrs = {};

    const txt = document.createElement("textarea");
    txt.innerHTML = str;
    const decodedStr = txt.value.replace(/[“”«»]/g, '"').replace(/[‘’]/g, "'");

    const attrRegex = /([a-zA-Z0-9_-]+)\s*=\s*(?:"([^"]*)"|'([^']*)')/gu;
    let match;

    while ((match = attrRegex.exec(decodedStr)) !== null) {
      const key = match[1].toLowerCase();
      const value = match[2] !== undefined ? match[2] : match[3];
      attrs[key] = value.trim();
    }

    return attrs;
  }

  renderShortcode(name, attrs, originalText) {
    if (name === "quote") {
      return this.buildQuote(attrs);
    }

    if (name === "insight") {
      return this.buildInsight(attrs);
    }

    if (name === "caption") {
      return this.buildCaption(attrs);
    }

    if (name === "list") {
      return this.buildList(attrs);
    }

    if (name === "cards") {
      return this.buildCards(attrs);
    }

    return originalText;
  }

  buildQuote(attrs) {
    const text = attrs["quote"] || "";
    const author = attrs["author"] || "";

    return `
      <div class="quote-wrapper bg-white rounded-3xl p-6 my-8 lg:my-12" style="border-left: solid 4px #E91E63;">
        <p class="quote-text">"${text}"</p>
        <p class="quote-author">- ${author}</p>
      </div>
    `;
  }

  buildInsight(attrs) {
    const title = attrs["title"] || "";
    const description = attrs["description"] || "";

    return `
      <div class="insight-wrapper rounded-2xl p-4 lg:p-6 mb-6 lg:mb-8" style="border: solid 1px #DD286333">
        <h4 class="insight-title">${title}</h4>
        <p class="insight-description">${description}</p>
      </div>
    `;
  }

  buildCaption(attrs) {
    const text = attrs["text"] || "";
    return `
      <p class="caption-text">${text}</p>
    `;
  }

  buildList(attrs) {
    let listHTML =
      '<div role="list" class="checklist mb-8 lg:mb-12 space-y-3 lg:space-y-4 flex flex-col">';
    let i = 1;

    let iconElement = "";
    if (attrs["icon"] && attrs["icon"].trim().startsWith("https://")) {
      const customIcon = attrs["icon"].trim();
      iconElement = `<img src="${customIcon}" alt="List icon" class="w-full h-full object-contain" />`;
    } else {
      iconElement = `<svg class="object-contain text-pink flex-shrink-0" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
          <path d="M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z" fill="currentColor"/>
          <path d="M17.3332 8L9.99984 15.3333L6.6665 12" stroke="white" stroke-width="2.66667" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>`;
    }

    while (attrs[`item${i}_title`]) {
      const title = attrs[`item${i}_title`];
      const desc = attrs[`item${i}_desc`] || "";

      listHTML += `
        <div role="listitem" class="flex gap-3 lg:gap-4 items-start lg:items-center h-fit">
          <div class="overflow-hidden h-6 w-6 flex-shrink-0">
            ${iconElement}
          </div>

          <p class="text-[#333333] lg:text-[1.125rem] lg:leading-8" style="margin:0px">
            <span class="font-body-semibold">${title}</span> ${desc}
          </p>
        </div>
      `;
      i++;
    }
    listHTML += "</div>";
    return listHTML;
  }

  buildCards(attrs) {
    let cardsHTML =
      '<div class="cards-grid">';

    for (let i = 1; i <= 3; i++) {
      if (attrs[`card${i}_value`]) {
        const value = attrs[`card${i}_value`];
        const label = attrs[`card${i}_label`] || "";

        cardsHTML += `
              <div class="card bg-white rounded-2xl p-4 lg:p-6 text-center flex flex-col items-center justify-center">
                <span class="block text-[2.5rem] leading-tight lg:text-6xl font-body-bold text-pink mb-2">${value}</span>
                <span class="text-[#666666] text-sm lg:text-base font-body-medium">${label}</span>
              </div>
             `;
      }
    }

    cardsHTML += "</div>";
    return cardsHTML;
  }
}

customElements.define("article-shortcodes", ArticleShortcodes);
